import { Model } from "@vuex-orm/core";
import Notification from "./notification";
import SiteGroup from "@/models/site_group";
import Device from "@/models/device";

export default class Measure extends Model {
  static entity = "measures";

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(""),
      description: this.attr(""),
      mode: this.attr(0),
      start_at: this.attr(null),
      end_at: this.attr(null),
      yaxis_unit: this.attr(""),
      notification: this.hasOne(Notification, "measure_id"),
      site_group: this.belongsTo(SiteGroup, "site_group_id"),
      site_group_id: this.attr(null),
      device: this.belongsTo(Device, "device_id"),
      device_id: this.attr(null),
    };
  }
}
